import { useEffect, useState } from "react"
import { useParams } from "react-router-dom";
import { addCard } from "services/api/redsys.service";
import { getPayCit, getPostBookingGlobick } from "services/user/user.session.service";

export function RedsysForm() {
    // example card = 4548810000000003	12/49	123
    // Tarjeta: 454881 204940 0004  / Cad: 12/49  / CVV : 123  / CIP: 123456
    // simulador firma = https://sis-d.redsys.es/sis/simulador/firmaSHA256.html

    //     454881 940777 7774    
    // Cad: 12/49
    //  CVV : 123 - Challnege PIN = 1234


    const { action } = useParams();
    const [merchantParameters, setMP] = useState("");
    const [url, setURL] = useState("");
    const [signature, setS] = useState("");
    const [signatureVersion, setSV] = useState("");
    const [showForm, setShowForm] = useState(false);
    const [isMock, setIsMock] = useState(window.sessionStorage["raas-payment-mock"] == "true");

    useEffect(() => {
        let actionLiteral = action ? action.split(":")[1] : undefined;
        if (actionLiteral) {
            switch (actionLiteral) {
                case PaymentAction.ADD_CARD:
                    addCardFlow()
                    break;
                case PaymentAction.REMOVE_CARD:
                    deleteCardFlow()
                    break;
                case PaymentAction.PAYMENT:
                    paymentFlow()
                    break;
                case PaymentAction.EXTERNAL_PAYMENT:
                    externalPaymentFlow()
                    break;
                case PaymentAction.DEFAULT_CARD:
                    defaultCardFlow()
                    break;
                case PaymentAction.ADD_CARD_GLOBICK:
                    addCardGlobickFlow()
                break;
                case PaymentAction.PAY_CIT:
                    payCitFlow()
                break;
                case PaymentAction.PAY_CIT_TMB:
                    payCitFlowTMB()
                break;

                
            }
        }
    }, [])


    const addCardFlow = () => {
        // petición a back para obtener merchanParameter
        addCard()
            .then((data: any) => {
                mountForm(data)
            })
            .catch(error => {
                console.error(error);
            })
    }


    const addCardGlobickFlow = () => {
        // petición a back para obtener merchanParameter
        addCard()
            .then((data: any) => {
                mountGlobickForm(data)
            })
            .catch(error => {
                console.error(error);
            })
    }

    
    
    const payCitFlow = () => {
        // levantamos pasadela de pago
        mountFormCitTmb(getPayCit())
        /*addCard()
            .then((data: any) => {
                mountForm(data)
            })
            .catch(error => {
                console.error(error);
            })*/
    }
    const payCitFlowTMB = () => {
        mountFormCitTmb(getPayCit())
    }

    


    const deleteCardFlow = () => {
        console.log("delete");
    }

    const externalPaymentFlow = () => {
        console.log("external payment");

    }

    const paymentFlow = () => {
        console.log("payment");

    }
    const defaultCardFlow = () => {
        console.log("default");

    }


    const mountFormCitTmb = (data: any) => {
        const { Ds_MerchantParameters, Ds_Signature, Ds_SignatureVersion,url } = data;
        setMP(Ds_MerchantParameters);
        if (isMock) setMP("eyJEc19NZXJjaGFudF9UZXJtaW5hbCI6IjEiLCJEc19NZXJjaGFudF9NZXJjaGFudENvZGUiOiI0MTkxMzE3OSIsIkRzX01lcmNoYW50X1Byb2R1Y3REZXNjcmlwdGlvbiI6IlJhYXMiLCJEc19NZXJjaGFudF9PcmRlciI6IjAwMDA1NDEwMDA1MyIsIkRzX01lcmNoYW50X1VybEtPIjoiaHR0cDpcL1wvbG9jYWxob3N0OjMwMDBcL2FwcFwvcmVkc3lzLWtvIiwiRHNfTWVyY2hhbnRfVGl0dWxhciI6IklzbWFlbCBSdWl6IiwiRHNfTWVyY2hhbnRfQ3VycmVuY3kiOiI5NzgiLCJEc19NZXJjaGFudF9NZXJjaGFudFVSTCI6Imh0dHA6XC9cL2xvY2FsaG9zdDozMDAwXC9hcHBcL3JlZHN5cyIsIkRzX01lcmNoYW50X1VybE9LIjoiaHR0cDpcL1wvbG9jYWxob3N0OjMwMDBcL2FwcFwvcmVkc3lzLW9rIiwiRHNfTWVyY2hhbnRfQ29uc3VtZXJMYW5ndWFnZSI6IjAiLCJEc19tZXJjaGFudF9tZXJjaGFudE5hbWUiOiJSYWFzIiwiRHNfTWVyY2hhbnRfQW1vdW50IjoiMCIsIkRzX01lcmNoYW50X1RyYW5zYWN0aW9uVHlwZSI6IjAiLCJEc19NZXJjaGFudF9JZGVudGlmaWVyIjoiUkVRVUlSRUQifQ");
        setS(Ds_Signature);
        if (isMock) setS("9O6Q2VChL/bQ4gYTffba66Yz4MmSGz7sejw/oiI9tJc=");
        setSV(Ds_SignatureVersion);
        if (isMock) setSV("HMAC_SHA256_V1");
        setURL(url);
        if (isMock) setURL("https://sis-t.redsys.es:25443/sis/realizarPago"); // t i d
        setShowForm(true);
        if (!isMock) {
            setTimeout(() => {
                // @ts-ignore
                document.myfrom.submit();
            }, 0);
        }
    }
    
    const mountFormCit = (data: any) => {
        const { redirect } = data;
        const { payload, url } = redirect[0];
        const { Ds_MerchantParameters, Ds_Signature, Ds_SignatureVersion } = payload;
        setMP(Ds_MerchantParameters);
        if (isMock) setMP("eyJEc19NZXJjaGFudF9UZXJtaW5hbCI6IjEiLCJEc19NZXJjaGFudF9NZXJjaGFudENvZGUiOiI0MTkxMzE3OSIsIkRzX01lcmNoYW50X1Byb2R1Y3REZXNjcmlwdGlvbiI6IlJhYXMiLCJEc19NZXJjaGFudF9PcmRlciI6IjAwMDA1NDEwMDA1MyIsIkRzX01lcmNoYW50X1VybEtPIjoiaHR0cDpcL1wvbG9jYWxob3N0OjMwMDBcL2FwcFwvcmVkc3lzLWtvIiwiRHNfTWVyY2hhbnRfVGl0dWxhciI6IklzbWFlbCBSdWl6IiwiRHNfTWVyY2hhbnRfQ3VycmVuY3kiOiI5NzgiLCJEc19NZXJjaGFudF9NZXJjaGFudFVSTCI6Imh0dHA6XC9cL2xvY2FsaG9zdDozMDAwXC9hcHBcL3JlZHN5cyIsIkRzX01lcmNoYW50X1VybE9LIjoiaHR0cDpcL1wvbG9jYWxob3N0OjMwMDBcL2FwcFwvcmVkc3lzLW9rIiwiRHNfTWVyY2hhbnRfQ29uc3VtZXJMYW5ndWFnZSI6IjAiLCJEc19tZXJjaGFudF9tZXJjaGFudE5hbWUiOiJSYWFzIiwiRHNfTWVyY2hhbnRfQW1vdW50IjoiMCIsIkRzX01lcmNoYW50X1RyYW5zYWN0aW9uVHlwZSI6IjAiLCJEc19NZXJjaGFudF9JZGVudGlmaWVyIjoiUkVRVUlSRUQifQ");
        setS(Ds_Signature);
        if (isMock) setS("9O6Q2VChL/bQ4gYTffba66Yz4MmSGz7sejw/oiI9tJc=");
        setSV(Ds_SignatureVersion);
        if (isMock) setSV("HMAC_SHA256_V1");
        setURL(url);
        if (isMock) setURL("https://sis-t.redsys.es:25443/sis/realizarPago"); // t i d
        setShowForm(true);
        if (!isMock) {
            setTimeout(() => {
                // @ts-ignore
                document.myfrom.submit();
            }, 0);
        }
    }

    const mountForm = (data: any) => {
        const { redirect } = data;
        const { payload, url } = redirect;
        const { Ds_MerchantParameters, Ds_Signature, Ds_SignatureVersion } = payload;
        setMP(Ds_MerchantParameters);
        if (isMock) setMP("eyJEc19NZXJjaGFudF9UZXJtaW5hbCI6IjEiLCJEc19NZXJjaGFudF9NZXJjaGFudENvZGUiOiI0MTkxMzE3OSIsIkRzX01lcmNoYW50X1Byb2R1Y3REZXNjcmlwdGlvbiI6IlJhYXMiLCJEc19NZXJjaGFudF9PcmRlciI6IjAwMDA1NDEwMDA1MyIsIkRzX01lcmNoYW50X1VybEtPIjoiaHR0cDpcL1wvbG9jYWxob3N0OjMwMDBcL2FwcFwvcmVkc3lzLWtvIiwiRHNfTWVyY2hhbnRfVGl0dWxhciI6IklzbWFlbCBSdWl6IiwiRHNfTWVyY2hhbnRfQ3VycmVuY3kiOiI5NzgiLCJEc19NZXJjaGFudF9NZXJjaGFudFVSTCI6Imh0dHA6XC9cL2xvY2FsaG9zdDozMDAwXC9hcHBcL3JlZHN5cyIsIkRzX01lcmNoYW50X1VybE9LIjoiaHR0cDpcL1wvbG9jYWxob3N0OjMwMDBcL2FwcFwvcmVkc3lzLW9rIiwiRHNfTWVyY2hhbnRfQ29uc3VtZXJMYW5ndWFnZSI6IjAiLCJEc19tZXJjaGFudF9tZXJjaGFudE5hbWUiOiJSYWFzIiwiRHNfTWVyY2hhbnRfQW1vdW50IjoiMCIsIkRzX01lcmNoYW50X1RyYW5zYWN0aW9uVHlwZSI6IjAiLCJEc19NZXJjaGFudF9JZGVudGlmaWVyIjoiUkVRVUlSRUQifQ");
        setS(Ds_Signature);
        if (isMock) setS("9O6Q2VChL/bQ4gYTffba66Yz4MmSGz7sejw/oiI9tJc=");
        setSV(Ds_SignatureVersion);
        if (isMock) setSV("HMAC_SHA256_V1");
        setURL(url);
        if (isMock) setURL("https://sis-t.redsys.es:25443/sis/realizarPago"); // t i d
        setShowForm(true);
        if (!isMock) {
            setTimeout(() => {
                // @ts-ignore
                document.myfrom.submit();
            }, 0);
        }
    }


    const mountGlobickForm = (data: any) => {
        const { urlPayment,signatureVersion,dsMerchantParameters,dsSignature } = getPostBookingGlobick();
        const { redirect } = data;
        const { payload, url } = redirect;
        const { Ds_MerchantParameters, Ds_Signature, Ds_SignatureVersion } = payload;
        setMP(dsMerchantParameters);
        if (isMock) setMP("eyJEc19NZXJjaGFudF9UZXJtaW5hbCI6IjEiLCJEc19NZXJjaGFudF9NZXJjaGFudENvZGUiOiI0MTkxMzE3OSIsIkRzX01lcmNoYW50X1Byb2R1Y3REZXNjcmlwdGlvbiI6IlJhYXMiLCJEc19NZXJjaGFudF9PcmRlciI6IjAwMDA1NDEwMDA1MyIsIkRzX01lcmNoYW50X1VybEtPIjoiaHR0cDpcL1wvbG9jYWxob3N0OjMwMDBcL2FwcFwvcmVkc3lzLWtvIiwiRHNfTWVyY2hhbnRfVGl0dWxhciI6IklzbWFlbCBSdWl6IiwiRHNfTWVyY2hhbnRfQ3VycmVuY3kiOiI5NzgiLCJEc19NZXJjaGFudF9NZXJjaGFudFVSTCI6Imh0dHA6XC9cL2xvY2FsaG9zdDozMDAwXC9hcHBcL3JlZHN5cyIsIkRzX01lcmNoYW50X1VybE9LIjoiaHR0cDpcL1wvbG9jYWxob3N0OjMwMDBcL2FwcFwvcmVkc3lzLW9rIiwiRHNfTWVyY2hhbnRfQ29uc3VtZXJMYW5ndWFnZSI6IjAiLCJEc19tZXJjaGFudF9tZXJjaGFudE5hbWUiOiJSYWFzIiwiRHNfTWVyY2hhbnRfQW1vdW50IjoiMCIsIkRzX01lcmNoYW50X1RyYW5zYWN0aW9uVHlwZSI6IjAiLCJEc19NZXJjaGFudF9JZGVudGlmaWVyIjoiUkVRVUlSRUQifQ");
        setS(dsSignature);
        if (isMock) setS("9O6Q2VChL/bQ4gYTffba66Yz4MmSGz7sejw/oiI9tJc=");
        setSV(signatureVersion);
        if (isMock) setSV("HMAC_SHA256_V1");
        setURL(url);
        if (urlPayment) setURL("https://sis-t.redsys.es:25443/sis/realizarPago"); // t i d
        setShowForm(true);
        if (!isMock) {
            setTimeout(() => {
                // @ts-ignore
                document.myfrom.submit();
            }, 0);
        }
    }

    return (
        <>
            {showForm &&
                <form name="myfrom" action={url} method="POST">
                    <input type="hidden" name="Ds_SignatureVersion" value={signatureVersion} />
                    <input type="hidden" name="Ds_MerchantParameters" value={merchantParameters} />
                    <input type="hidden" name="Ds_Signature" value={signature} />
                    {isMock &&
                        <input type="submit" value={"mandar, quitar luego este botón"} />
                    }
                </form>
            }


        </>
    )
}

export enum PaymentAction {
    ADD_CARD = "addCard",
    PAYMENT = "payment",
    REMOVE_CARD = "removeCard",
    EXTERNAL_PAYMENT = "externalPayment",
    DEFAULT_CARD = "defaultCard",
    ADD_CARD_GLOBICK="addCardGlobick",
    PAY_CIT="payCit",
    PAY_CIT_TMB="payCitTmb"
}